import { Outlet } from 'react-router-dom';
import { DEMO_URL } from '../../links';
import { ApiStatus } from './ApiStatus';
import { Brand } from './Brand';

/** Public auth pages: brand panel on the left, the form on the right. */
export function AuthLayout() {
  return (
    <div className="auth">
      <aside className="auth__side">
        <Brand to="/sign-in" light />
        <div className="auth__statement">
          <p className="eyebrow eyebrow--light">Balsam Solutions</p>
          <h2>The hub for tenant organizations and the team that onboards them.</h2>
          <p>
            Owners manage their organization, billing and team here. Balsam staff run onboarding,
            provisioning and support from the same place.
          </p>
        </div>
        <p className="auth__fineprint">
          Want a look first?{' '}
          <a href={DEMO_URL} target="_blank" rel="noopener noreferrer">
            Try the demo
          </a>
          .
        </p>
      </aside>
      <div className="auth__panel">
        <div className="auth__card">
          <Outlet />
        </div>
        <footer className="auth__footer">
          <ApiStatus />
        </footer>
      </div>
    </div>
  );
}
